import { useAuth0 } from '@auth0/auth0-react';
import _ from 'lodash';
import { UserRoles } from '../../constants';

const checkUserRole = (userRole) => (state) => {
  const { user: auth0user } = useAuth0();
  if (auth0user && auth0user.userRoles && auth0user.userRoles.length) {
    let { userRoles } = auth0user;
    if (state && state.user.travelAgency && !state.user.travelAgency.isPrimaryTravelAgencyForUser
      && auth0user.userRoles.includes(UserRoles.ADMIN)) {
      // If not primary travel agency for the logged-in user then don't allow admin access.
      // Allow agent level access
      userRoles = _.without(auth0user.userRoles, UserRoles.ADMIN);
      userRoles.push(UserRoles.AGENT);
    }
    return userRoles.includes(userRole);
  }
  return false;
};

export default checkUserRole;
